/* unplugin-vue-components disabled */import script from "./company-introduction.vue?vue&type=script&setup=true&lang=ts"
export * from "./company-introduction.vue?vue&type=script&setup=true&lang=ts"

import "./company-introduction.vue?vue&type=style&index=0&id=31780974&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31780974"]])

export default __exports__